import { TEmergencyContact } from '@/services/user';

type Parent = {
  idetification: { number: string };
  firstName: string;
  lastName: string;
  connection?: string;
  identification: { number: string };
  phone: string;
  email: string;
};

export default function AditionalDataSection({
  t,
  additionalData,
  emergencyContact
}: Readonly<{
  t: any;
  additionalData: any;
  emergencyContact: TEmergencyContact | undefined;
}>) {
  return (
    <div className="space-y-4">
      <div>
        {(emergencyContact?.fullName || additionalData?.emergencyContact) && (
          <>
            <p className="text-sm text-muted-foreground">
              {t('activity.student.emergencyContact')}:
            </p>

            <div className="mt-2">
              <p>
                <span>{t('activity.student.contactName')}:</span>
                &nbsp;
                {emergencyContact?.fullName ??
                  additionalData?.emergencyContact?.fullName}
              </p>
              <p>
                <span>{t('activity.student.phone')}:</span>
                &nbsp;
                {emergencyContact?.phone ??
                  additionalData?.emergencyContact?.phone}
              </p>
            </div>
          </>
        )}
      </div>
      <div>
        {additionalData?.parents && (
          <p className="text-sm text-muted-foreground">
            {t('activity.student.contacts')}:
          </p>
        )}
        {additionalData?.parents?.map((parent: Parent) => {
          if (!parent?.firstName) return null;

          return (
            <div key={parent?.identification?.number} className="mt-2">
              <p>
                <span>{t('activity.student.contactName')}:</span>
                &nbsp;
                {parent?.firstName}&nbsp;{parent?.lastName}
              </p>
              {parent?.connection && (
                <p>
                  <span>{t('activity.student.contactRelation')}:</span>
                  &nbsp;{parent?.connection}
                </p>
              )}
              <p>
                <span>{t('activity.student.contactDNI')}:</span>
                &nbsp;{parent?.identification?.number}
              </p>
              <p>
                <span>{t('activity.student.contactPhone')}:</span>
                &nbsp;{parent?.phone}
              </p>
              <p>
                <span>{t('activity.student.contactEmail')}:</span>
                &nbsp;{parent?.email}
              </p>
            </div>
          );
        })}
      </div>
      {additionalData?.illness?.value && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.addtionalData.illness')}:
          </p>
          <p>{additionalData?.illness?.answer}</p>
        </div>
      )}
      {additionalData?.acceptTakePhotos !== undefined && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.addtionalData.acceptTakePhotos')}:
          </p>
          <p>
            {additionalData?.acceptTakePhotos
              ? t('common.yes')
              : t('common.no')}
          </p>
        </div>
      )}
      {additionalData?.authOfferProducts !== undefined && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.addtionalData.authOfferProducts')}:
          </p>
          <p>
            {additionalData?.authOfferProducts
              ? t('common.yes')
              : t('common.no')}
          </p>
        </div>
      )}
      {additionalData?.insurance && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.student.medicalCoverage')}:
          </p>
          <p>{additionalData?.insurance}</p>
        </div>
      )}
      {additionalData?.experience && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.student.waterSkillLevel')}:
          </p>
          <p>{additionalData?.experience}</p>
        </div>
      )}
      {additionalData?.holidayDate && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.student.vacationPeriod')}:
          </p>
          <p>{additionalData?.holidayDateDetails}</p>
        </div>
      )}
      {additionalData?.isEmployeePartner && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('isEmployeePartner')}:
          </p>
          <p>{additionalData?.isEmployeePartner}</p>
        </div>
      )}
      {additionalData?.isPartner !== undefined && (
        <div>
          <p className="text-sm text-muted-foreground">
            {t('activity.student.clubMember')}:
          </p>
          <p>{`${additionalData?.isPartner ? t('form.yes') : t('form.no')}`}</p>
        </div>
      )}
    </div>
  );
}
